import React from "react";
import {Box, Container, Grid} from "@mui/material";


export type FloatingBlockProps = {
    children?: any
    className?: string
}


export const FloatingActions = (props: FloatingBlockProps) => {
    const {children, className} = props;
    return (
        <Box position="fixed" bottom={0} left={0} right={0} pb={2} pt={2} zIndex="1000" className={className}>
            <Container>
                <Grid container direction="column" spacing={1}>
                    {React.Children.map(children, (child, index) => (
                        <Grid item key={index}>
                            {child}
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}